// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Integrations_buttonWrapper__Zc7--","gatewayCard":"Integrations_gatewayCard__L6-Br","gatewayList":"Integrations_gatewayList__jGjJw"};